interface PageLoaderProps {
  title?: string;
  message?: string;
}

export default function PageLoader({
  title = 'Loading',
  message = 'Please wait while we sync your data.',
}: PageLoaderProps) {
  return (
    <div className="min-h-[40vh] flex flex-col items-center justify-center gap-4 text-center px-6">
      <div
        className="w-14 h-14 rounded-full flex items-center justify-center text-white"
        style={{ backgroundColor: 'var(--accent)' }}
      >
        <i className="ri-loader-4-line animate-spin text-2xl"></i>
      </div>
      <div className="space-y-1">
        <p className="text-base font-bold text-white">{title}</p>
        <p className="text-sm text-white/50 max-w-md">{message}</p>
      </div>
    </div>
  );
}
